module.exports = __webpack_public_path__ + "img/fees-collected.74a58849.svg";